import { Link } from 'react-router-dom'

export default function Home() {
  return (
    <div className="min-h-screen">
      {/* Hero */}
      <section className="bg-gradient-to-br from-indigo-50 to-white py-20">
        <div className="max-w-7xl mx-auto px-4 text-center">
          <h1 className="text-5xl md:text-6xl font-bold text-gray-900 mb-6">
            Build Amazing Products Faster
          </h1>
          <p className="text-xl text-gray-600 mb-10 max-w-3xl mx-auto">
            The all-in-one platform that helps teams ship better software with confidence, speed, and zero headaches.
          </p>
          <div className="space-x-4">
            <Link to="/request-demo">
              <button className="bg-indigo-600 text-white px-8 py-4 rounded-lg text-lg font-semibold hover:bg-indigo-700 transition shadow-lg">
                Request a Demo
              </button>
            </Link>
            <Link to="/contact">
              <button className="border border-gray-300 text-gray-700 px-8 py-4 rounded-lg text-lg font-semibold hover:border-indigo-600 hover:text-indigo-600 transition">
                Contact Sales
              </button>
            </Link>
          </div>
        </div>
      </section>

      {/* Features */}
      <section className="py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4">
          <h2 className="text-4xl font-bold text-center mb-12">Why Teams Love Us</h2>
          <div className="grid md:grid-cols-3 gap-10">
            {[
              { title: "Blazing Fast", desc: "Deploy in seconds, not hours" },
              { title: "Secure by Default", desc: "Enterprise-grade security built-in" },
              { title: "Scale Infinitely", desc: "From startup to unicorn" }
            ].map((f) => (
              <div key={f.title} className="bg-white p-8 rounded-xl shadow-md text-center">
                <div className="w-16 h-16 bg-indigo-100 rounded-full mx-auto mb-4"></div>
                <h3 className="text-2xl font-bold mb-3">{f.title}</h3>
                <p className="text-gray-600">{f.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-gray-900 text-white py-12">
        <div className="max-w-7xl mx-auto px-4 text-center">
          <p>&copy; 2025 YourCompany. All rights reserved.</p>
        </div>
      </footer>
    </div>
  )
}